/* eslint-disable */
import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import router from './router'
import lottie from 'vue-lottie';
import animate from 'animate.css';
import VueClipboard from 'vue-clipboard2'

import XLSX from 'xlsx'
Vue.use(VueClipboard)
Vue.prototype.XLSX = XLSX 
Vue.use(ElementUI);
Vue.component('lottie', lottie)

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
})

new Vue({
  render: h => h(App),
  router
}).$mount('#app')

